import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import ProtectedRoute from '@/components/ProtectedRoute';
import AuthPage from '@/pages/AuthPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardLayout from '@/pages/DashboardLayout';
import DashboardHome from '@/pages/DashboardHome';
import PatientsPage from '@/pages/PatientsPage';
import TherapistsPage from '@/pages/TherapistsPage';
import ResourcesPage from '@/pages/ResourcesPage';
import ReportsPage from '@/pages/ReportsPage';
import AppointmentsPage from '@/pages/AppointmentsPage';
import InstitutionPage from '@/pages/InstitutionPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import UsersManagementPage from '@/pages/UsersManagementPage';
import AuditLogsPage from '@/pages/AuditLogsPage';
import ProfilePage from '@/pages/ProfilePage';
import AdminPanelPage from '@/pages/AdminPanelPage';
import GlobalAdminPanelPage from '@/pages/GlobalAdminPanelPage';
import AcceptInvitePage from '@/pages/AcceptInvitePage';
import ManualPage from '@/pages/ManualPage';
import TrashCenterPage from '@/pages/TrashCenterPage';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="patients" element={<PatientsPage />} />
            <Route path="therapists" element={<TherapistsPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="institution" element={<InstitutionPage />} />
            <Route path="users" element={<UsersManagementPage />} />
            <Route path="admin-panel" element={<AdminPanelPage />} />
            <Route path="global-panel" element={<GlobalAdminPanelPage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="manual" element={<ManualPage />} />
            <Route path="trash" element={<TrashCenterPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
